import ko from "knockout";
import config from "config";
import Globalize from "globalize";
import moment from "moment";
import cldrLocaleOverrides from "cultures/cldrLocaleOverrides";
import { loadLocale } from "i18n";
import { getDecodedQueryParamsFromWindow } from "util/uriUtil";
import languageList from "strings/languageList.json";

const supportedLocales = Object.keys(languageList);

let appLocale = "en-US";

function isSupportedLocale(locale) {
    return supportedLocales.includes(locale);
}

function getQueryLocale() {
    const queryParams = getDecodedQueryParamsFromWindow();
    const queryLocale = queryParams.locale;
    if (queryLocale) {
        const [language, region] = queryLocale.replace("_", "-").split("-");
        if (region) {
            const locale = `${language.toLowerCase()}-${region.toUpperCase()}`;
            if (isSupportedLocale(locale)) {
                return locale;
            }
        }
        if (isSupportedLocale(language.toLowerCase())) {
            return language;
        }
    }
}

function getBrowserLanguage() {
    return navigator.languages.find(isSupportedLocale);
}

/**
 * Module for requesting that locale data be loaded into the application.
 * @exports services/localeService
 */
const localeService = {
    /**
     * Gets the current locale the application should be in, based on user preferences, browser config, and default settings.
     */
    getAppLocale: function () {
        return getQueryLocale() || getBrowserLanguage() || config.defaultLocale;
    },

    getLocale() {
        return appLocale;
    },

    setLocale(locale) {
        const notifySubscribers = this.getLocale() !== locale;
        appLocale = locale || "en-US";
        moment.locale(appLocale);
        // Certain locales need to be referenced differently in globalize than in our i18n strings
        // e.g. "no" (Norwegian) is "nb" in the CLDR data used by globalize
        const globalizeLocale = cldrLocaleOverrides[appLocale] || appLocale;
        Globalize.locale(globalizeLocale);
        if (notifySubscribers) {
            localeService.onLocaleChanged.notifySubscribers();
        }
    },
    loadLocale,
    onLocaleChanged: ko.observable(),
};

export default localeService;
